import { ExpressPaymentMethods } from '../../constants/statsig';
import { getGooglePayOnTicketSelectionExperimentValue } from '../../utils/statsig';

export const useIsGooglePayOnTicketSelectionExperimentEnabled = (): boolean =>
    getGooglePayOnTicketSelectionExperimentValue() ===
    ExpressPaymentMethods.gpay;
